<h1 mat-dialog-title>Przypisz odpowiedzialnego użytkownika</h1>

@if (loader()) {
	<div class="w-100 d-flex justify-content-center align-items-center" style="height: 200px">
		<mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
	</div>
} @else {
	@let requiredError = searchControl.hasError('required');

	<mat-dialog-content>
		<mat-form-field appearance="outline" class="w-100">
			<input type="text" matInput placeholder="Wyszukaj" [formControl]="searchControl" [matAutocomplete]="auto" />
			<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
				@for (item of allUsers(); track item.id) {
					<mat-option [value]="item">{{ item.firstName }} {{ item.lastName }}</mat-option>
				}
			</mat-autocomplete>

			@if (requiredError) {
				<mat-error>To pole jest wymagane</mat-error>
			}
		</mat-form-field>
	</mat-dialog-content>

	<mat-dialog-actions align="end"
		><button
			[disabled]="requiredError || userIsSelected()"
			mat-raised-button
			color="primary"
			(click)="assignUser(searchControl.value)"
		>
			Przypisz
		</button>
		<button mat-raised-button color="primary" (click)="assignMe()">Przypisz mnie</button></mat-dialog-actions
	>
}
